import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Search from './pages/Search';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import Account from './pages/Account';
import VCFirmDetail from './pages/details/VCFirmDetail';
import OrganizationDetail from './pages/details/OrganizationDetail';
import AngelDetail from './pages/details/AngelDetail';
import POIDetail from './pages/details/POIDetail';
import AuthGuard from './components/auth/AuthGuard';


const AppRoutes: React.FC = () => (
    <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route element={<AuthGuard />} >
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/search" element={<Search />} />
            <Route path="/account" element={<Account />} />
            <Route path="/vc/:id" element={<VCFirmDetail />} />
            <Route path="/organization/:id" element={<OrganizationDetail />} />
            <Route path="/angel/:id" element={<AngelDetail />} />
            <Route path="/poi/:id" element={<POIDetail />} />
        </Route>
    </Routes>
);

export default AppRoutes;
